import React, { Component } from "react";
import AUX from "../../hoc/Aux_";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { prediketList, searchrdfquery, mapData } from "../../api/kugi";
import TablePropertyType from "../../components/Kugi/tablePropertyType";
import BorderColor from "@material-ui/icons/BorderColor";
import ArrowBack from "@material-ui/icons/ArrowBackIos";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Config from "../../config/";
import Axios from "axios";
import MapDialog from "../Map/MapDialog";
import LoaderSPO from "../../components/UI/Loader/LoaderSPO1";
import LoaderBig from "../../components/UI/Loader/LoaderBig";

const ROOT_URL = Config.rooturl;
let cancelToken;

class PencarianDetailObjek extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      objectId: "",
      resultQuery: [],
      subjek: "",
      namaprediket: [],
      labelprediket: [],
      wmsSubLayer: [],
      wmsLayer: "big",
      loadingMap: true,
      loading: true,
      listSublayer: [
        { sublayer: "taswil_desa_ar", filter: "kdepum" },
        { sublayer: "taswil_kabkot_ar", filter: "kdpkab" },
        { sublayer: "taswil_kabkot_ln", filter: "object_id" },
        { sublayer: "toponim_pt", filter: "object_id" },
      ],
    };
  }

  componentWillMount = async() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const foo = params.get("id");
    this.setState({ objectId: foo });
    await prediketList()
      .then((res) => {
        res.data.map((item) => {
          let placeholder = item.namaprediket.split("#");
          this.setState({
            namaprediket: [...this.state.namaprediket, placeholder[1]],
            labelprediket: [...this.state.labelprediket, item.labelprediket],
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
    this.handleListMap(foo)
    this.handleFetch(foo)
  }

  handleFetch = async (item) => {
    this.setState({
      resultQuery: [],
    });
    const predikatStatis = [
      "memilikiNAMGAZ",
      "memilikiNAMMAP",
      "memilikiNAMSPE",
      "memilikiKOORDY",
      "memilikiKOORDX",
      "memilikiTIPADM",
      "BerbatasanDengan",
      "memilikiWADMKK",
      "memilikiWADMPR",
      "memilikiKLSTPN",
      "memilikiNAMLOK",
      "memilikiARTINAM",
      "memilikiFOTO1",
      "memilikiFOTO2",
      "memilikiFOTO3",
      "memilikiFOTO4",
    ];
    let objekTest;
    if (cancelToken) {
      cancelToken.cancel("Request cancelled");
    }
    cancelToken = Axios.CancelToken.source();
    objekTest = `@${item}`;
    await Promise.all(
      predikatStatis.map(async (predikat) => {
        await searchrdfquery(predikat, objekTest, "", cancelToken.token)
          .then(async (res) => {
            if (res.data.length !== 0) {
              this.setState({
                resultQuery: [...this.state.resultQuery, res.data],
              });
            }
            if (predikat === "memilikiNAMMAP") {
              this.setState({subjek: res.data[0].subjek})
            }
          })
          .catch((err) => {});
      })
    )
      .then(() => {
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  };

  handlePrediket = (prediket) => {
    let temp = this.state.namaprediket.indexOf(prediket);
    return this.state.labelprediket[temp];
  };

  handleKoor = (item) => {
    try {
      let temp = item.split("^", 1);
      return temp;
    } catch {
      return item;
    }
  };

  handleListMap = async (objectId) => {
    this.setState({ loadingMap: true, wmsSubLayer: [] });
    await Promise.all(
      this.state.listSublayer.map(async (item) => {
        await mapData(item.sublayer, objectId, item.filter)
          .then((res) => {
            if (res.data.features.length !== 0) {
              this.setState({
                wmsSubLayer: [...this.state.wmsSubLayer, res.data],
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
    ).then(() => {
      this.setState({ loadingMap: false });
      console.log(this.state.wmsSubLayer);
    });
  };

  render() {
    return (
      <AUX>
        <section className="sections" style={{ paddingTop: "5%" }}>
          <div className="container">
            <Grid item xs={12}>
              <Alert
                severity="info"
                // action={
                //   <Button color="inherit" size="small">
                //     <a
                //       href={`${ROOT_URL}featuretypegetbycode?code=${
                //         this.state.code
                //       }`}
                //       target="_blank"
                //     >
                //       Akses API
                //     </a>{" "}
                //   </Button>
                // }
              >
                {" "}
                <Link to="pencarianbig">
                  <ArrowBack /> Kembali ke hasil pencarian
                </Link>
                <span
                  style={{
                    position: "absolute",
                    right: 350,
                    width: 200,
                    height: 120,
                  }}
                />
              </Alert>
              <Paper style={{ padding: 10 }}>
                <React.Fragment>
                  <br />
                  <Grid container spacing={3}>
                    <Grid item xs={10}>
                      <h4>{this.state.objectId}</h4>
                      {/* {this.state.subjek ? <LoaderBig/> : <h4>{this.state.subjek}</h4>} */}
                    </Grid>
                    {/* <Grid item xs={3}>
                <Button>
                  <Link to={`/mapdetail?id=${this.props.objekId}`}>
                    <a>Go to Map</a>
                  </Link>
                </Button>
              </Grid> */}
                  </Grid>
                  <br />
                  <Grid container spacing={3} style={{ marginBottom: 20 }} justify="center">
                    {this.state.objectId === null ? null : (
                      <React.Fragment>
                        <Grid
                          item
                          xs={5}
                          style={{
                            backgroundColor: "#eaecf0",
                            border: "1px solid #c8ccd1",
                          }}
                        >
                          <b>Map</b>
                        </Grid>
                        <Grid
                          item
                          xs={5}
                          style={{
                            backgroundColor: "#FFF",
                            border: "1px solid #c8ccd1",
                          }}
                        >
                          <b>Gambar Map</b>
                        </Grid>
                        {this.state.wmsSubLayer.map((item, index) => (
                          <React.Fragment>
                            <Grid
                              item
                              xs={5}
                              style={{
                                backgroundColor: "#eaecf0",
                                border: "1px solid #c8ccd1",
                              }}
                            >
                              {item.features[0].nama_layer}
                            </Grid>
                            <Grid
                              item
                              xs={5}
                              style={{
                                backgroundColor: "#FFF",
                                border: "1px solid #c8ccd1",
                                // position: "relative"
                              }}
                            >
                              <MapDialog
                                id={this.state.objectId}
                                layer={this.state.wmsLayer}
                                sublayer={item.features[0].sublayer}
                                filter={item.features[0].filter}
                                data={item.features[0].data}
                                json={item}
                                type={item.features[0].geometry.type}
                              />
                            </Grid>
                          </React.Fragment>
                        ))}
                        {this.state.loadingMap ? (
                          <React.Fragment>
                            <Grid
                              item
                              xs={5}
                              style={{
                                backgroundColor: "#eaecf0",
                                border: "1px solid #c8ccd1",
                              }}
                            >
                              <LoaderSPO />
                            </Grid>
                            <Grid
                              item
                              xs={5}
                              style={{
                                backgroundColor: "#FFF",
                                border: "1px solid #c8ccd1",
                              }}
                            >
                              <LoaderSPO />
                            </Grid>
                          </React.Fragment>
                        ) : null}
                        {!this.state.loadingMap &&
                        this.state.wmsSubLayer.length === 0 ? (
                          <React.Fragment>
                            <Grid
                              item
                              xs={5}
                              style={{
                                backgroundColor: "#eaecf0",
                                border: "1px solid #c8ccd1",
                              }}
                            >
                              Tidak ada map
                            </Grid>
                            <Grid
                              item
                              xs={5}
                              style={{
                                backgroundColor: "#FFF",
                                border: "1px solid #c8ccd1",
                              }}
                            >
                              Tidak ada gambar map
                            </Grid>
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    )}
                    <Grid
                      item
                      xs={5}
                      style={{
                        backgroundColor: "#eaecf0",
                        border: "1px solid #c8ccd1",
                      }}
                    >
                      <b>Predikat</b>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      style={{
                        backgroundColor: "#FFF",
                        border: "1px solid #c8ccd1",
                      }}
                    >
                      <b>Objek</b>
                    </Grid>
                    {this.state.resultQuery.map((item) => (
                      <React.Fragment>
                        <Grid
                          item
                          xs={5}
                          style={{
                            backgroundColor: "#eaecf0",
                            border: "1px solid #c8ccd1",
                          }}
                        >
                          <a
                            style={{
                              cursor: "pointer",
                              color: "blue",
                            }}
                            // onClick={() =>
                            //   this.props.search(
                            //     item[0].prediket,
                            //     this.handlePrediket(item[0].prediket),
                            //     "predikat"
                            //   )
                            // }
                          >
                            {this.handlePrediket(item[0].prediket)}
                          </a>
                        </Grid>
                        <Grid
                          item
                          xs={5}
                          style={{
                            backgroundColor: "#FFF",
                            border: "1px solid #c8ccd1",
                          }}
                        >
                          {item.length > 1 ? (
                            <>
                              {item.map((result) => (
                                <li>
                                  {result.objek.includes("http://") ? (
                                    <Link
                                      to={{ pathname: result.objek }}
                                      target="_blank"
                                    >
                                      <a>{result.objek}</a>
                                    </Link>
                                  ) : (
                                    <a
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                      }}
                                      // onClick={() =>
                                      //   // {this.props.objekId ? this.props.searchObject(result.objek) : this.props.searchSPO(result)}
                                      //   this.props.search(
                                      //     result.objek,
                                      //     result.objek,
                                      //     "objek"
                                      //   )
                                      // }
                                    >
                                      {result.objek}
                                    </a>
                                  )}
                                </li>
                              ))}
                            </>
                          ) : item[0].objek.includes("http://") ? (
                            item[0].prediket === "memilikiKOORDY" ||
                            item[0].prediket === "memilikiKOORDX" ? (
                              <p>
                                <a
                                  style={{
                                    cursor: "pointer",
                                    color: "blue",
                                  }}
                                  // onClick={() =>
                                  //   // {this.props.objekId ? this.props.searchObject(item[0].objek) : this.props.searchSPO(item[0])}
                                  //   this.props.search(
                                  //     item[0].objek,
                                  //     item[0].objek,
                                  //     "objek"
                                  //   )
                                  // }
                                >
                                  {this.handleKoor(item[0].objek)}
                                  {/* {item[0].objek} */}
                                </a>
                              </p>
                            ) : (
                              <Link
                                to={{ pathname: item[0].objek }}
                                target="_blank"
                              >
                                <a>{item[0].objek}</a>
                              </Link>
                            )
                          ) : (
                            <p>
                              <a
                                style={{
                                  cursor: "pointer",
                                  color: "blue",
                                }}
                                // onClick={() =>
                                //   // {this.props.objekId ? this.props.searchObject(item[0].objek) : this.props.searchSPO(item[0])}
                                //   this.props.search(
                                //     item[0].objek,
                                //     item[0].objek,
                                //     "objek"
                                //   )
                                // }
                              >
                                {this.handleKoor(item[0].objek)}
                                {/* {item[0].objek} */}
                              </a>
                            </p>
                          )}
                        </Grid>
                      </React.Fragment>
                    ))}
                    {this.state.loading ? (
                      <React.Fragment>
                        <Grid
                          item
                          xs={5}
                          style={{
                            backgroundColor: "#eaecf0",
                            border: "1px solid #c8ccd1",
                          }}
                        >
                          <LoaderSPO />
                        </Grid>
                        <Grid
                          item
                          xs={5}
                          style={{
                            backgroundColor: "#FFF",
                            border: "1px solid #c8ccd1",
                          }}
                        >
                          <LoaderSPO />
                        </Grid>
                      </React.Fragment>
                    ) : null}
                    {!this.state.loading && this.state.resultQuery.length === 0 ? (
                      <React.Fragment>
                        <Grid
                          item
                          xs={5}
                          style={{
                            backgroundColor: "#eaecf0",
                            border: "1px solid #c8ccd1",
                          }}
                        >
                          Tidak ada data
                        </Grid>
                        <Grid
                          item
                          xs={5}
                          style={{
                            backgroundColor: "#FFF",
                            border: "1px solid #c8ccd1",
                          }}
                        >
                          Tidak ada data
                        </Grid>
                      </React.Fragment>
                    ) : null}
                  </Grid>
                </React.Fragment>
              </Paper>
            </Grid>
            <div className="container">
              <div className="row justify-content-center" id="counter" />
            </div>
          </div>
        </section>
      </AUX>
    );
  }
}

export default PencarianDetailObjek;
